import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DatePicker from "react-datepicker";
import {
  Delete,
  Visibility,
  Download,
  PagesRounded,
  ShieldMoon,
} from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "../../assets/scss/styles/timeline.css";
import { numberFormat } from "../../Utils/comman";

function PiView(props) {
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const [piData, setPiData] = useState([]);
  const [status, setStatus] = useState("");
  const [storeStatus, setStoreStatus] = useState("");
  const [note, setNote] = useState("");
  const [readNote, setReadNote] = useState("");
  const [dispatchDate, setdispatchDate] = useState(new Date());
  const [storeNote, setStoreNote] = useState("");
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1200);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1200);
  const [loadingAccept, setLoadingAccept] = useState(false); // State to manage loading for Accept button
  const [loadingReject, setLoadingReject] = useState(false);
  const [errors, setErrors] = useState({});
  const [storeErrors, setStoreErrors] = useState({});
  const [orderStatus, setOrderStatus] = useState(0);

  const [orderProducts, setOrderProducts] = useState([]);

  const dispatch = useDispatch();
  const fields = [
    { label: "Proforma Invoice No.", key: "invoice_no" },
    { label: "Dated", key: "invoice_date" },
    { label: "Delivery Note", key: "delivery_note" },

    { label: "Mode/Terms of Payment", key: "payment_terms" },
    { label: "Reference No. & Date.", key: "ref_no_date" },
    { label: "Other References", key: "other_ref" },
    { label: "Buyer’s Order No.", key: "buyers_order_no" },
    { label: "Dated", key: "buyers_order_date" },
    { label: "Dispatch Doc No.", key: "dispacth_doc_no" },

    { label: "Delivery Note Date", key: "delivery_note_date" },
    { label: "Dispatched through", key: "dispatched_through" },

    { label: "Destination", key: "destination" },
  ];

  const discounts = [
    {
      key: "quantity_discount_per",
      value: "quantity_discount",
      label: "Quantity Discount",
      extra: "Less:",
    },
    {
      key: "cash_discount_per",
      value: "cash_discount",
      label: "Cash Discount",
      extra: "Less:",
    },
    {
      key: "special_discount_per",
      value: "special_discount",
      label: "Special Discount",
      extra: "Less:",
    },
    {
      key: "freight_amount",
      value: "freight_amount",
      label: "Freight Amount",
      extra: "",
    },
    {
      key: "insurance_per",
      value: "insurance_amount",
      label: "Insurance",
      extra: "",
    },
    { key: "igst_per", value: "igst", label: "IGST", extra: "" },
    { key: "sgst_per", value: "sgst", label: "SGST", extra: "" },
    { key: "cgst_per", value: "cgst", label: "CGST", extra: "" },
    { key: "rounding", label: "Rounding", extra: "Less", value: "roundoff" },
  ];

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  const activeUser = userProfile?.user_role[0]?.roleName;

  const isSalesCoordinator = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Sales_Coordinator_permissions"
  );
  const isStoreManager = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Store_Manager_permissions"
  );

  const isBrandManager = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Brand_Manager_permissions"
  );
  const checkUserRoleById = (roleId) => {
    return (
      userProfile?.user_role.filter((role) => parseInt(role.id) === roleId)
        .length ?? false
    );
  };
  //const isBrandManager = checkUserRoleById(28);

  const userId = userProfile?.employeeId;
  const rowData = props?.rowData;

  const isUserIdMatched = (idString) => {
    if (!idString) return false;
    const ids = idString.split(",");
    return ids.includes(userId);
  };
  console.log("Heeee", isUserIdMatched(rowData?.cfo_id));
  const isRelevantUser =
    isUserIdMatched(rowData?.ceo_id) ||
    isUserIdMatched(rowData?.cfo_id) ||
    isUserIdMatched(rowData?.rsm_id) ||
    isUserIdMatched(rowData?.channel_partner_id);

  // const isRelevantUser =
  //   userId === rowData?.ceo_id ||
  //   userId === rowData?.cfo_id ||
  //   userId === rowData?.rsm_id ||
  //   userId === rowData?.channel_partner_id;

  // const IsRsm = activeUser === "Regional Sales Manager";
  // const IsCfo = activeUser === "Regional Sales Manager";
  // const IsCeo = activeUser === "Regional Sales Manager";

  const approvalNoteKeys = [
    { key: "rsm_approve_note", label: "RSM Note", id: rowData?.rsm_id },
    {
      key: "channel_partner_approve_note",
      label: "Channel Partner Note",
      id: rowData?.channel_partner_id,
    },
    { key: "cfo_approve_note", label: "CFO Note", id: rowData?.cfo_id },
    { key: "ceo_approve_note", label: "CEO Note", id: rowData?.ceo_id },
  ];

  const isApprovalStatusZero = () => {
    const isUserIdMatched = (idString) => {
      if (!idString) return false;
      const ids = idString.split(",");
      return ids.includes(userId);
    };

    if (isUserIdMatched(rowData?.ceo_id)) {
      return rowData?.ceo_approve_status === "0";
    } else if (isUserIdMatched(rowData?.cfo_id)) {
      return rowData?.cfo_approve_status === "0";
    } else if (isUserIdMatched(rowData?.rsm_id)) {
      return rowData?.rsm_approve_status === "0";
    } else if (isUserIdMatched(rowData?.channel_partner_id)) {
      return rowData?.channel_partner_approve_status === "0";
    }

    return false;
  };

  // const isApprovalStatusZero = () => {
  //   if (userId === rowData?.ceo_id) {
  //     return rowData?.ceo_approve_status === "0";
  //   } else if (userId === rowData?.cfo_id) {
  //     return rowData?.cfo_approve_status === "0";
  //   } else if (userId === rowData?.rsm_id) {
  //     return rowData?.rsm_approve_status === "0";
  //   } else if (userId === rowData?.channel_partner_id) {
  //     return rowData?.channel_partner_approve_status === "0";
  //   }
  //   return false;
  // };

  const isApprovalStatusRejected = () => {
    if (userId === rowData?.ceo_id) {
      return rowData?.ceo_approve_status === "2";
    } else if (userId === rowData?.cfo_id) {
      return rowData?.cfo_approve_status === "2";
    } else if (userId === rowData?.rsm_id) {
      return rowData?.rsm_approve_status === "2";
    } else if (userId === rowData?.channel_partner_id) {
      return rowData?.channel_partner_approve_status === "2";
    }
    return false;
  };

  const getApprovalNote = () => {
    if (userId === rowData?.rsm_id && rowData?.rsm_approve_note !== null) {
      return rowData?.rsm_approve_note;
    } else if (
      userId === rowData?.channel_partner_id &&
      rowData?.channel_partner_approve_note !== null
    ) {
      return rowData?.channel_partner_approve_note;
    } else if (
      userId === rowData?.cfo_id &&
      rowData?.cfo_approve_note !== null
    ) {
      return rowData?.cfo_approve_note;
    } else if (
      userId === rowData?.ceo_id &&
      rowData?.ceo_approve_note !== null
    ) {
      return rowData?.ceo_approve_note;
    }
    return "";
  };

  // Use useEffect to set the note state based on the approval note
  useEffect(() => {
    const approvalNote = getApprovalNote();

    setReadNote(approvalNote);
  }, [userId, rowData]);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getPiData();
  }, []);

  const getPiData = () => {
    // console.log(props.rowData)
    const orderId =
      props?.rowData?.orderdata && props?.rowData?.orderdata.id
        ? props?.rowData?.orderdata.id
        : props?.rowData?.id;
    //userProfile?.user_role[0]?.roleName === "Sales Co-Ordinator Team"
    //             ? props?.rowData?.id
    //             : props?.rowData?.order_id
    utils
      .callAPI("get", `/sales/getInvoiceList?id=${orderId}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          let orderStatus = parseInt(res?.order_status);
          if (isNaN(orderStatus) && res?.orderdata) {
            orderStatus = parseInt(res?.orderdata?.order_status);
          }

          const products = [...res?.Proforma_invoice_products];
          products.map((product) => {
            product.size = (product.size * 1).toFixed(2);
            product.total_qty = (
              product.total_qty ? parseFloat(product.total_qty) : 0
            ).toFixed(2);
          });

          setOrderProducts(products);
          setOrderStatus(orderStatus);
          setPiData(res);
        } else {
          setPiData([]);
        }
      })
      .catch((err) => {
        setPiData([]);
      });
  };

  const handleBackClick = (e) => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleDownload = () => {
    // window.open(
    //   `http://tms.vura.ae/dev/Vura_API_Server/src/api/sales/pi_download/${props.rowData?.id}`,
    //   "_blank"
    // );

    utils
      .callAPI("get", `sales/pi_download/${piData?.id}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          // window.open(res, "_blank");
          const a = document.createElement("a");
          a.href = res;
          a.target = "_blank"; // or "_self" depending on your preference
          a.rel = "noopener noreferrer";
          a.click();
        } else {
          //setPiData([]);
        }
      })
      .catch((err) => {
        // setPiData([]);
      });
  };

  const sendStatus = (type) => {
    if (type === "accept") {
      setLoadingAccept(true); // Start loader for Accept button
    } else {
      setLoadingReject(true); // Start loader for Reject button
    }

    var bodyFormData = new FormData();
    if (status !== "") {
      bodyFormData.append("id", props?.rowData?.id);
      bodyFormData.append("status", status);
      bodyFormData.append("remarks", note);
      utils
        .callAPI(
          "post",
          `${
            piData.store_location_approve_status === "1"
              ? "/sales/approve_pi_dispatch_by_sco"
              : "/sales/approve_pi_by_reporting_manager"
          }`,
          bodyFormData
        )
        .then((res) => {
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader for Accept button
          } else {
            setLoadingReject(false); // Stop loader for Reject button
          }

          if (typeof res !== "undefined") {
            Swal.fire({
              title: "Success!",
              text:
                status === "1"
                  ? "The invoice has been accepted."
                  : "The invoice has been rejected.",
              icon: "success",
              confirmButtonText: "OK",
            });

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            // Handle undefined response
          }
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: "There was an error processing your request.",
            icon: "error",
            confirmButtonText: "OK",
          });
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader on error for Accept button
          } else {
            setLoadingReject(false); // Stop loader on error for Reject button
          }

          // Handle error
        });
    }
  };

  const sendStoreStatus = (type) => {
    if (type === "accept") {
      setLoadingAccept(true); // Start loader for Accept button
    } else {
      setLoadingReject(true); // Start loader for Reject button
    }

    var bodyFormData = new FormData();
    if (storeStatus !== "") {
      bodyFormData.append("id", props?.rowData?.id);
      bodyFormData.append("status", storeStatus);
      bodyFormData.append("remarks", storeNote);
      bodyFormData.append(
        "dispatch_date",
        moment(dispatchDate).format("YYYY-MM-DD")
      );
      utils
        .callAPI("post", `/sales/approve_pi_by_store_location`, bodyFormData)
        .then((res) => {
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader for Accept button
          } else {
            setLoadingReject(false); // Stop loader for Reject button
          }

          if (typeof res !== "undefined") {
            Swal.fire({
              title: "Success!",
              text:
                storeStatus === "1"
                  ? "The Order has been accepted."
                  : "The Order has been rejected.",
              icon: "success",
              confirmButtonText: "OK",
            });

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            // Handle undefined response
          }
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: "There was an error processing your request.",
            icon: "error",
            confirmButtonText: "OK",
          });
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader on error for Accept button
          } else {
            setLoadingReject(false); // Stop loader on error for Reject button
          }

          // Handle error
        });
    }
  };

  useEffect(() => {
    // If there are no validation errors and status is set, call sendStatus
    if (status === "1" || status === "2") {
      if (status === "1") {
        sendStatus("accept");
      } else if (status === "2") {
        sendStatus("reject");
      }
    }
  }, [status, note]);

  useEffect(() => {
    // If there are no validation errors and status is set, call sendStatus
    if (storeStatus === "1" || storeStatus === "2") {
      if (storeStatus === "1") {
        sendStoreStatus("accept");
      } else if (storeStatus === "2") {
        sendStoreStatus("reject");
      }
    }
  }, [storeStatus, storeNote]);

  const handleAccept = () => {
    setStatus("1");
  };

  const handleReject = (e) => {
    // handleRejectChange("reject");
    const validationErrors = validate();
    setErrors(validationErrors);

    if (note !== "") setStatus("2");
  };

  const handleStoreAccept = () => {
    setStoreStatus("1");
  };

  const handleStoreReject = (e) => {
    // handleRejectChange("reject");
    const validationErrors = storeValidate();
    setStoreErrors(validationErrors);

    if (storeNote !== "") setStoreStatus("2");
  };

  const storeValidate = () => {
    const newErrors = {};
    if (!storeNote) {
      newErrors.storeNote = "Note is required";
    }
    return newErrors;
  };

  const validate = () => {
    const newErrors = {};
    if (!note) {
      newErrors.note = "Comment is required";
    }
    return newErrors;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Update the corresponding state based on the input name
    if (name === "note") {
      setNote(value);
      console.log(errors, "yeh hai");
      // Clear validation error for the 'note' field when user starts typing
      setErrors((prevErrors) => ({
        ...prevErrors,
        note: value ? "" : prevErrors.note,
      }));
    }
  };

  const handleStoreInputChange = (e) => {
    const { name, value } = e.target;

    // Update the corresponding state based on the input name
    if (name === "storeNote") {
      setStoreNote(value);

      setStoreErrors((prevErrors) => ({
        ...prevErrors,
        storeNote: value ? "" : prevErrors.storeNote,
      }));
    }
  };

  return (
    <div className="section-body">
      <RB.Card className="card ">
        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action">
            <RB.Button className="btn btn-light me-2" onClick={handleDownload}>
              Download
            </RB.Button>
            <RB.Button className="btn btn-light" onClick={handleBackClick}>
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <div className={"pi-invoice"}>
            <RB.Row className={"border"}>
              <RB.Col md={12} className={"py-2 text-center"}>
                <h6 className={"mb-0"}>PROFORMA INVOICE</h6>
              </RB.Col>
            </RB.Row>

            <RB.Row className={"border border-top-0"}>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Supplier - Seller:</strong>
                </h6>
                <p className={"mb-0"}>
                  <strong>{piData.registered_office?.company_name}</strong>
                </p>
                <p className={"mb-0"}>
                  {piData.registered_office?.address}
                  <br />
                  {piData.registered_office?.city} -{" "}
                  {piData.registered_office?.pincode}
                </p>
                <p className={"mb-0"}>
                  <strong>State:</strong> {piData.registered_office?.state}
                </p>
                <RB.Row>
                  <RB.Col md={6}>
                    <strong>GSTIN:</strong> {piData.registered_office?.gstno}
                  </RB.Col>
                  {/*<RB.Col md={6}>
                    <strong>PAN:</strong> AABCS4338M
                  </RB.Col>*/}
                </RB.Row>

                {/*<RB.Row>
                  <RB.Col md={6}>
                    <strong>CIN:</strong> U26109TN1997PL037875
                  </RB.Col>
                  <RB.Col md={6}>
                    <strong>TAN:</strong> CHES05530A
                  </RB.Col>
                </RB.Row>*/}
              </RB.Col>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Recipient - Customer :</strong>
                </h6>
                <>
                  <p className={"mb-0"}>
                    <strong>{piData?.bill_to_companyName}</strong>
                  </p>
                  <p className={"mb-0"}>
                    {piData?.bill_to_company_address},<br />
                    {piData?.bill_to_company_district},<br />
                    {piData?.bill_to_company_city} -{" "}
                    {piData?.bill_to_company_pincode},<br />
                    {/*Ph. : BILL TO PHONE<br/>*/}
                  </p>
                  <p className={"mb-0"}>
                    <strong>State:</strong> {piData?.bill_to_company_state}
                  </p>
                  <p className={"mb-0"}>
                    <strong>GSTIN:</strong> {piData?.bill_to_gst_no}
                  </p>
                </>
              </RB.Col>
              <RB.Col md={4} className={"border1 py-2"}>
                <p className={"mb-0"}>
                  <strong>Proforma Invoice No.: </strong> {piData?.invoice_no}
                </p>
                <p className={"mb-0"}>
                  <strong>Proforma Invoice Date: </strong>{" "}
                  {moment(piData?.invoice_date).format("DD-MM-YYYY")}
                </p>
                <p className={"mb-0"}>
                  <strong>Sales Order No.: </strong>{" "}
                  {piData?.orderdata?.order_id}
                </p>
                <p className={"mb-0"}>
                  <strong>Sales Order Date: </strong>{" "}
                  {moment(piData?.order_date).format("DD-MM-YYYY")}
                </p>
                <p className={"mb-0"}>
                  <strong>Ref.: </strong> {piData?.emp_ref_no}
                </p>
                <RB.Row className={"border-top"}>
                  <RB.Col>
                    <p className={"mb-0"}>
                      <strong>Mode/Terms of Payment: </strong>{" "}
                      {piData?.payment_terms}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Delivery Note: </strong> {piData?.delivery_note}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Reference No. & Date: </strong>{" "}
                      {piData?.ref_no_date}
                    </p>
                    <p className={"mb-0"}>
                      <strong>Other References: </strong> {piData?.other_ref}
                    </p>
                  </RB.Col>
                </RB.Row>
              </RB.Col>
            </RB.Row>

            <RB.Row className={"border border-top-0"}>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Destination Center:</strong>
                </h6>
                <>
                  <p className={"mb-0"}>
                    <strong>{piData?.location_data?.name}</strong>
                  </p>
                  <p className={"mb-0"}>
                    {piData?.location_data?.address},<br />
                    {/*{piData?.location_data?.district},<br/>*/}
                    {piData?.location_data?.city} -{" "}
                    {piData.location_data?.pincode},<br />
                    {piData.location_data?.state}
                  </p>
                </>
              </RB.Col>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Ship - To :</strong>
                </h6>
                <>
                  <p className={"mb-0"}>
                    <strong>{piData?.ship_to_companyName}</strong>
                  </p>
                  <p className={"mb-0"}>
                    {piData?.ship_to_company_address},<br />
                    {piData?.ship_to_company_city},<br />
                    {piData.ship_to_company_state} -{" "}
                    {piData.ship_to_company_pincode}
                  </p>
                </>
              </RB.Col>
              <RB.Col md={4} className={"border1 py-2"}>
                <p className={"mb-0"}>
                  <strong>Buyer’s Order No.: </strong> {piData?.buyers_order_no}
                </p>
                <p className={"mb-0"}>
                  <strong>Dated: </strong> {piData?.buyers_order_date}
                </p>
                <p className={"mb-0"}>
                  <strong>Dispatch Doc No.: </strong> {piData?.dispacth_doc_no}
                </p>
                <p className={"mb-0"}>
                  <strong>Delivery Note Date: </strong>{" "}
                  {piData?.delivery_note_date}
                </p>
                <p className={"mb-0"}>
                  <strong>Dispatched through: </strong>{" "}
                  {piData?.dispatched_through}
                </p>
                <p className={"mb-0"}>
                  <strong>Destination: </strong> {piData?.destination}
                </p>
              </RB.Col>
            </RB.Row>

            <RB.Row className={"border border-bottom-0"}>
              <h5 className="mt-3">Products</h5>

              <div className={"table-responsive p-0 border"}>
                <RB.Table
                  bordered
                  hover
                  striped
                  className="border mb-0 table-sm table-invoice-products"
                >
                  <thead>
                    <tr>
                      <th rowSpan={2}>S.No</th>
                      <th rowSpan={2}>Description of Goods</th>
                      <th className={"text-center"} rowSpan={2}>
                        UOM
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        HSN
                      </th>
                      <th className={"text-center"}>CGST</th>
                      <th className={"text-center"}>SGST</th>
                      <th className={"text-center"}>IGST</th>
                      <th className={"text-center"} rowSpan={2}>
                        Rate / UOM
                      </th>
                      <th colSpan={3} className={"text-center"}>
                        Quantity
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        Gross Value
                      </th>
                      <th className={"text-center"} colSpan={4}>
                        Discounts
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        Net Value
                      </th>
                    </tr>
                    <tr>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>In UOM</th>
                      <th className={"text-center"}>Pack Size</th>
                      <th className={"text-center"}>Total Qty(Kg)</th>
                      <th className={"text-center"}>Trade (%)</th>
                      <th className={"text-center"}>Quantity (%)</th>
                      <th className={"text-center"}>Cash (%)</th>
                      <th className={"text-center"}>Special (%)</th>
                    </tr>
                  </thead>

                  <tbody>
                    {orderProducts.length &&
                      orderProducts.map((product, index) => (
                        <tr key={index}>
                          <td className={"text-center"}>{index + 1}</td>
                          <td>{product.product_name}</td>
                          <td className={"text-center"}>
                            {(product.mou || "").toUpperCase()}
                          </td>
                          <td className={"text-center"}>
                            {product.hsn_code || ""}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.cgst || 0).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.sgst || 0).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.igst || 0).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {numberFormat(product.rate)}
                          </td>
                          <td className={"text-end"}>{product.qty}</td>
                          <td className={"text-end"}>
                            {parseFloat(product.size).toFixed(2)}
                          </td>
                          <td className={"text-end"}>{product.total_qty}</td>
                          <td className={"text-end"}>
                            {numberFormat(product.gross_value)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.discount_per || 0).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.qty_discount || 0).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.cash_discount || 0).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product.special_discount || 0).toFixed(
                              2
                            )}
                          </td>
                          <td className={"text-end"}>
                            {numberFormat(product.amount)}
                          </td>
                        </tr>
                      ))}
                  </tbody>

                  <tfoot>
                    <tr>
                      <th colSpan={9}></th>
                      <th className={"text-end"}>Total</th>
                      <th className={"text-end"}>
                        {parseFloat(piData?.toatl_qty).toFixed(2)}
                      </th>
                      <th className={"text-end"}>
                        {numberFormat(piData?.total_gross)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(piData?.total_volume_discount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(piData?.total_qty_discount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(piData?.total_cash_discount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(piData?.total_special_discount)}
                      </th>
                      <th className={"text-end"}>
                        {numberFormat(piData?.sub_total)}
                      </th>
                    </tr>
                  </tfoot>
                </RB.Table>
              </div>
            </RB.Row>

            <RB.Row>
              <RB.Col md={7} className={"border border-top-0"}>
                <RB.Row className={"border-bottom py-1"}>
                  <RB.Col>
                    <strong>Total in Words: {piData?.amount_in_word}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row>
                  <RB.Col>
                    <strong>Terms and Conditions</strong>
                    <ul>
                      {piData?.delivery_terms
                        ? piData?.delivery_terms
                            .split("\n")
                            .map(function (item, idx) {
                              return <li key={idx}>{item}</li>;
                            })
                        : " "}
                    </ul>
                  </RB.Col>
                </RB.Row>
              </RB.Col>
              <RB.Col md={5} className={"border"}>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col md={5} className={"border-end py-1"}>
                    Net Amount
                  </RB.Col>
                  <RB.Col md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(piData?.sub_total)}</strong>
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col md={5} className={"border-end py-1"}>
                    Insurance{" "}
                    {piData?.insurance_per > 0
                      ? `(${piData?.insurance_per}%)`
                      : ""}
                  </RB.Col>
                  <RB.Col md={7} className={"text-end py-1"}>
                    <strong>
                      {numberFormat(
                        piData?.insurance_amount > 0
                          ? piData?.insurance_amount
                          : 0
                      )}
                    </strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col md={5} className={"border-end py-1"}>
                    Freight Amount (₹)
                  </RB.Col>
                  <RB.Col md={7} className={"text-end py-1"}>
                    <strong>
                      {numberFormat(
                        piData?.freight_amount > 0 ? piData?.freight_amount : 0
                      )}
                    </strong>
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col md={5} className={"border-end py-1"}>
                    CGST
                  </RB.Col>
                  <RB.Col md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(piData?.cgst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col md={5} className={"border-end py-1"}>
                    SGST
                  </RB.Col>
                  <RB.Col md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(piData?.sgst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col md={5} className={"border-end py-1"}>
                    IGST
                  </RB.Col>
                  <RB.Col md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(piData?.igst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col md={5} className={"border-end py-1"}>
                    TCS {piData?.tcs_per ? `(${piData?.tcs_per} %)` : ""}
                  </RB.Col>
                  <RB.Col md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(piData?.tcs)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col md={5} className={"border-end py-1"}>
                    Round Off
                  </RB.Col>
                  <RB.Col md={7} className={"text-end py-1"}>
                    <strong>{piData?.roundoff}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center bg-light"}>
                  <RB.Col md={5} className={"border-end py-1"}>
                    <strong>Invoice Total</strong>
                  </RB.Col>
                  <RB.Col md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(piData?.main_total)}</strong>
                  </RB.Col>
                </RB.Row>
              </RB.Col>
            </RB.Row>
          </div>

          {!isBrandManager && piData?.comments !== "" ? (
            <>
              <h6 className="mt-4">Comments</h6>
              <hr className="hr-lg mt-1" />
              <RB.Table
                responsive
                bordered
                hover
                striped
                className="table-responsive "
              >
                <thead>
                  <tr>
                    <th style={{ width: "5%" }}>Sr</th>
                    <th style={{ width: "35%" }}>Comment</th>
                    <th style={{ width: "25%" }}>Name</th>
                    <th style={{ width: "20%" }}>Role</th>
                    <th style={{ width: "15%" }}>Commented Date</th>
                  </tr>
                </thead>
                <tbody>
                  {piData?.comments?.map((comment, index) => (
                    <tr key={comment.id}>
                      <td style={{ width: "5%" }}>{index + 1}</td>
                      <td style={{ width: "35%" }}>{comment.comment}</td>
                      <td style={{ width: "25%" }}>{comment.commenter_name}</td>
                      <td style={{ width: "20%" }}>{comment.commenter_role}</td>
                      <td style={{ width: "15%" }}>
                        {moment(comment.createdAt).format(
                          "DD-MM-YYYY HH:mm:ss A"
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </RB.Table>
            </>
          ) : (
            ""
          )}

          {piData?.store_location_dispatch_date !== "0000-00-00 00:00:00" &&
            piData?.store_location_dispatch_date !== null &&
            isSalesCoordinator && (
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Dispatch Date
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {moment(piData?.store_location_dispatch_date).format(
                    "DD-MM-YYYY"
                  )}
                </p>
              </RB.Col>
            )}

          {/* {!isRelevantUser &&
            isApprovalStatusRejected &&
            approvalNoteKeys.map(({ key, label, id }) => {
              const notes = rowData?.pi_response?.[key];

              return (
                notes !== null && (
                  <div key={key}>
                    <h6>{label}</h6>
                    <hr className="hr-lg mt-1" />
                    <div>
                      <RB.Col md={12} className="no-validation-icon">
                        <div className="mb-3">
                          <RB.FloatingLabel
                            controlId={key}
                            className="floating-label-fancy"
                          >
                            <RB.Form.Control
                              as="textarea"
                              type="text"
                              //     placeholder="Enter Your Comment here"
                              name={key}
                              value={notes}
                              maxLength={500}
                              readOnly
                            />
                          </RB.FloatingLabel>
                        </div>
                      </RB.Col>
                    </div>
                  </div>
                )
              );
            })} */}

          {/* {isRelevantUser && !isApprovalStatusZero() && (
            <>
              <h6>Comment</h6>
              <hr className="hr-lg mt-1" />
              <div>
                <RB.Col md={12} className="no-validation-icon">
                  <div className="mb-3">
                    <RB.FloatingLabel
                      controlId="readnote"
                      //label="Enter Your Comment here"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        as="textarea"
                        type="text"
                        placeholder="Enter Your Comment here"
                        name="readnote"
                        value={readNote}
                        // onChange={handleInputChange}
                        maxLength={500}
                        // required={status === "0"}
                        readOnly
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              </div>
            </>
          )} */}
          {(isRelevantUser && isApprovalStatusZero()) ||
          (piData.store_location_approve_status === "1" &&
            !isStoreManager &&
            (orderStatus === 18 || orderStatus === 21)) ? (
            // (piData.store_location_approve_status === "1" && !isStoreManager && !isBrandManager) ? (
            <>
              <h6>Comment</h6>
              <hr className="hr-lg mt-1" />
              <div>
                <RB.Col md={12} className="no-validation-icon">
                  <div className="mb-3">
                    <RB.FloatingLabel
                      controlId="note"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        as="textarea"
                        type="text"
                        placeholder="Enter your note here"
                        name="note"
                        value={note}
                        onChange={handleInputChange}
                        maxLength={500}
                        isInvalid={!!errors.note}
                        // required={status !== "1"}
                      />
                      <RB.Form.Control.Feedback type="invalid">
                        {errors.note}
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>

                <>
                  <RB.Button
                    className="me-2"
                    style={{ backgroundColor: "#37c830", color: "white" }}
                    onClick={handleAccept}
                    disabled={loadingAccept} // Disable button while loading
                  >
                    {loadingAccept ? (
                      <RB.Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Accept"
                    )}
                  </RB.Button>
                  <RB.Button
                    style={{ backgroundColor: "red", color: "white" }}
                    onClick={handleReject}
                    disabled={loadingReject} // Disable button while loading
                  >
                    {loadingReject ? (
                      <RB.Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Reject"
                    )}
                  </RB.Button>
                </>
              </div>
            </>
          ) : null}

          {isStoreManager && piData.store_location_approve_status === "0" && (
            <>
              <h6>Comment</h6>
              <hr className="hr-lg mt-1" />

              <RB.Row>
                <RB.Col md={6} className="no-validation-icon">
                  <div className="mb-3 mt-3">
                    <RB.FloatingLabel
                      label="Dispatch Date"
                      className={`floating-label-fancy ${
                        dispatchDate ? "dateSelected" : "dateempty"
                      }`}
                    >
                      <DatePicker
                        selected={dispatchDate}
                        onChange={(date) => setdispatchDate(date)}
                        dateFormat="dd-MM-yyyy"
                        className="form-control"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"

                        // placeholderText="Order Date"
                        // required
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>

                <RB.Col md={6} className="no-validation-icon">
                  <div className="mb-3">
                    <RB.FloatingLabel
                      controlId="storeNote"
                      className="floating-label-fancy"
                      label="Note"
                    >
                      <RB.Form.Control
                        as="textarea"
                        type="text"
                        placeholder="Enter your note here"
                        name="storeNote"
                        value={storeNote}
                        onChange={handleStoreInputChange}
                        maxLength={500}
                        isInvalid={!!storeErrors.storeNote}
                        // required={status !== "1"}
                      />
                      <RB.Form.Control.Feedback type="invalid">
                        {storeErrors.storeNote}
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              </RB.Row>
              <div>
                {
                  <>
                    <RB.Button
                      className="me-2"
                      style={{ backgroundColor: "#37c830", color: "white" }}
                      onClick={handleStoreAccept}
                      disabled={loadingAccept} // Disable button while loading
                    >
                      {loadingAccept ? (
                        <RB.Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Accept"
                      )}
                    </RB.Button>
                    <RB.Button
                      style={{ backgroundColor: "red", color: "white" }}
                      onClick={handleStoreReject}
                      disabled={loadingReject} // Disable button while loading
                    >
                      {loadingReject ? (
                        <RB.Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Reject"
                      )}
                    </RB.Button>
                  </>
                }
              </div>
            </>
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default PiView;
